<template>
  <b-form>
    <div v-if="readOnly" class="row">
      <div v-for="document in documentList" :key="document.key" class="col-md-6 mb-3">
        <label>{{ document.label }}</label>
        <div v-if="documents[document.key] && documents[document.key].url">
          <a :href="documents[document.key].url" target="_blank" rel="noopener">{{ documents[document.key].name || 'Unduh dokumen' }}</a>
        </div>
        <span v-else class="text-muted">Belum tersedia</span>
      </div>
    </div>
    <div v-else class="row">
      <div class="col-md-6 mb-3">
        <label for="undangan_persiapan">Undangan Persiapan <span class="text-danger">*</span></label>
        <small class="d-block">Format file: PDF</small>
        <div class="d-flex">
          <b-form-file id="undangan_persiapan" v-model="form.undangan_persiapan" accept=".pdf,application/pdf" v-validate="'required'" name="Undangan Persiapan" plain class="form-control" @change="validateFile($event, 'undangan_persiapan', 'pdf')" />
          <b-button class="ms-2" variant="primary" :disabled="!form.undangan_persiapan" @click="uploadFile('undangan_persiapan', 'pdf')"><i class="fa fa-cloud-upload" /> Unggah</b-button>
          <b-button class="ms-2" variant="success" :disabled="!uploadedFiles.undangan_persiapan" @click="downloadFile('undangan_persiapan')"><i class="fa fa-download" /> Unduh</b-button>
        </div>
        <span v-if="errors.has('Undangan Persiapan')" class="text-danger">{{ errors.first('Undangan Persiapan') }}</span>
        <span v-if="fileErrors.undangan_persiapan" class="text-danger">File harus berformat PDF.</span>
      </div>

      <div class="col-md-6 mb-3">
        <label for="undangan_kegiatan">Undangan Kegiatan <span class="text-danger">*</span></label>
        <small class="d-block">Format file: PDF</small>
        <div class="d-flex">
          <b-form-file id="undangan_kegiatan" v-model="form.undangan_kegiatan" accept=".pdf,application/pdf" v-validate="'required'" name="Undangan Kegiatan" plain class="form-control" @change="validateFile($event, 'undangan_kegiatan', 'pdf')" />
          <b-button class="ms-2" variant="primary" :disabled="!form.undangan_kegiatan" @click="uploadFile('undangan_kegiatan', 'pdf')"><i class="fa fa-cloud-upload" /> Unggah</b-button>
          <b-button class="ms-2" variant="success" :disabled="!uploadedFiles.undangan_kegiatan" @click="downloadFile('undangan_kegiatan')"><i class="fa fa-download" /> Unduh</b-button>
        </div>
        <span v-if="errors.has('Undangan Kegiatan')" class="text-danger">{{ errors.first('Undangan Kegiatan') }}</span>
        <span v-if="fileErrors.undangan_kegiatan" class="text-danger">File harus berformat PDF.</span>
      </div>

      <div class="col-md-6 mb-3">
        <label for="kak">KAK <span class="text-danger">*</span></label>
        <small class="d-block">Format file: PDF</small>
        <div class="d-flex">
          <b-form-file id="kak" v-model="form.kak" accept=".pdf,application/pdf" v-validate="'required'" name="KAK" plain class="form-control" @change="validateFile($event, 'kak', 'pdf')" />
          <b-button class="ms-2" variant="primary" :disabled="!form.kak" @click="uploadFile('kak', 'pdf')"><i class="fa fa-cloud-upload" /> Unggah</b-button>
          <b-button class="ms-2" variant="success" :disabled="!uploadedFiles.kak" @click="downloadFile('kak')"><i class="fa fa-download" /> Unduh</b-button>
        </div>
        <span v-if="errors.has('KAK')" class="text-danger">{{ errors.first('KAK') }}</span>
        <span v-if="fileErrors.kak" class="text-danger">File harus berformat PDF.</span>
      </div>

      <div class="col-md-6 mb-3">
        <label for="desk_study">Desk Study <span class="text-danger">*</span></label>
        <small class="d-block">Format file: PDF</small>
        <div class="d-flex">
          <b-form-file id="desk_study" v-model="form.desk_study" accept=".pdf,application/pdf" v-validate="'required'" name="Desk Study" plain class="form-control" @change="validateFile($event, 'desk_study', 'pdf')" />
          <b-button class="ms-2" variant="primary" :disabled="!form.desk_study" @click="uploadFile('desk_study', 'pdf')"><i class="fa fa-cloud-upload" /> Unggah</b-button>
          <b-button class="ms-2" variant="success" :disabled="!uploadedFiles.desk_study" @click="downloadFile('desk_study')"><i class="fa fa-download" /> Unduh</b-button>
        </div>
        <span v-if="errors.has('Desk Study')" class="text-danger">{{ errors.first('Desk Study') }}</span>
        <span v-if="fileErrors.desk_study" class="text-danger">File harus berformat PDF.</span>
      </div>

      <div class="col-md-6 mb-3">
        <label for="surat_tugas">Surat Tugas <span class="text-danger">*</span></label>
        <small class="d-block">Format file: PDF</small>
        <div class="d-flex">
          <b-form-file id="surat_tugas" v-model="form.surat_tugas" accept=".pdf,application/pdf" v-validate="'required'" name="Surat Tugas" plain class="form-control" @change="validateFile($event, 'surat_tugas', 'pdf')" />
          <b-button class="ms-2" variant="primary" :disabled="!form.surat_tugas" @click="uploadFile('surat_tugas', 'pdf')"><i class="fa fa-cloud-upload" /> Unggah</b-button>
          <b-button class="ms-2" variant="success" :disabled="!uploadedFiles.surat_tugas" @click="downloadFile('surat_tugas')"><i class="fa fa-download" /> Unduh</b-button>
        </div>
        <span v-if="errors.has('Surat Tugas')" class="text-danger">{{ errors.first('Surat Tugas') }}</span>
        <span v-if="fileErrors.surat_tugas" class="text-danger">File harus berformat PDF.</span>
      </div>

      <div class="col-md-6 mb-3">
        <label for="data_drone">Data Drone <span class="text-danger">*</span></label>
        <small class="d-block">Format file: SHP</small>
        <div class="d-flex">
          <b-form-file id="data_drone" v-model="form.data_drone" accept=".shp" v-validate="'required'" name="Data Drone" plain class="form-control" @change="validateFile($event, 'data_drone', 'shp')" />
          <b-button class="ms-2" variant="primary" :disabled="!form.data_drone" @click="uploadFile('data_drone', 'shp')"><i class="fa fa-cloud-upload" /> Unggah</b-button>
          <b-button class="ms-2" variant="success" :disabled="!uploadedFiles.data_drone" @click="downloadFile('data_drone')"><i class="fa fa-download" /> Unduh</b-button>
        </div>
        <span v-if="errors.has('Data Drone')" class="text-danger">{{ errors.first('Data Drone') }}</span>
        <span v-if="fileErrors.data_drone" class="text-danger">File harus berformat SHP.</span>
      </div>
    </div>
  </b-form>
</template>

<script>
export default {
  props: {
    readOnly: { type: Boolean, default: false },
    documents: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      form: {
        undangan_persiapan: null,
        undangan_kegiatan: null,
        kak: null,
        desk_study: null,
        surat_tugas: null,
        data_drone: null,
      },
      uploadedFiles: {},
      fileErrors: {},
    }
  },
  computed: {
    documentList() {
      return [
        { key: 'undangan_persiapan', label: 'Undangan Persiapan' },
        { key: 'undangan_kegiatan', label: 'Undangan Kegiatan' },
        { key: 'kak', label: 'KAK' },
        { key: 'desk_study', label: 'Desk Study' },
        { key: 'surat_tugas', label: 'Surat Tugas' },
        { key: 'data_drone', label: 'Data Drone' },
      ]
    },
  },
  methods: {
    validateFile(event, key, extension) {
      if (this.readOnly) return
      const file = event.target.files[0]
      this.$set(this.fileErrors, key, Boolean(file && !file.name.toLowerCase().endsWith(`.${extension}`)))
      if (!file || this.fileErrors[key]) this.$set(this.uploadedFiles, key, null)
    },
    uploadFile(key, extension) {
      if (this.readOnly) return
      const file = this.form[key]
      this.$set(this.fileErrors, key, Boolean(file && !file.name.toLowerCase().endsWith(`.${extension}`)))
      if (!this.fileErrors[key]) this.$set(this.uploadedFiles, key, file)
    },
    downloadFile(key) {
      if (this.readOnly) return
      const file = this.uploadedFiles[key]
      if (!file) return
      const url = URL.createObjectURL(file)
      const link = document.createElement('a')
      link.href = url
      link.download = file.name
      link.click()
      setTimeout(() => URL.revokeObjectURL(url), 1000)
    },
    async validateForm() {
      const valid = await this.$validator.validateAll()
      return valid && !this.errors.any() && !Object.values(this.fileErrors).some(Boolean)
    },
    getFormData() {
      return { ...this.form }
    },
  },
}
</script>
